var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import debounce from "lodash/debounce";
import React, { useCallback, useState } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
export { Highlighter, MenuItem } from "react-bootstrap-typeahead";
function doNotFilter() {
    return true;
}
function Searchbox(props) {
    var _a, _b;
    const { id, onSearch, defaultOptions, label } = props, restProps = __rest(props, ["id", "onSearch", "defaultOptions", "label"]);
    const [options, setOptions] = useState();
    const [loading, setLoading] = useState(0);
    const search = useCallback(debounce((query) => __awaiter(this, void 0, void 0, function* () {
        setLoading(x => x + 1);
        try {
            const newOptions = yield onSearch(query);
            setOptions(newOptions);
        }
        finally {
            setLoading(x => x - 1);
        }
    }), (_a = props.debounce) !== null && _a !== void 0 ? _a : 500), [onSearch]);
    return (React.createElement(AsyncTypeahead, Object.assign({}, restProps, { inputProps: { id: id }, onSearch: search, isLoading: loading > 0, options: (_b = options !== null && options !== void 0 ? options : defaultOptions) !== null && _b !== void 0 ? _b : [], filterBy: doNotFilter })));
}
export default Searchbox;
//# sourceMappingURL=index.js.map